import React from 'react';
import { Switch as AntdSwitch, Space, Tooltip } from 'antd';
import Title from 'antd/lib/typography/Title';
import { InfoCircleOutlined } from '@ant-design/icons';
interface SwitchProps {
  id: string;
  placeholder: string;
  secondLabel?: string;
  name: string;
  onHandleChange: (checked: boolean) => void;
  defaultChecked: boolean;
  isDisabled?: boolean;
}

export const Switch: React.FC<SwitchProps> = ({
  id,
  name,
  placeholder,
  secondLabel,
  onHandleChange,
  defaultChecked,
  isDisabled,
}) => {
  if (name === 'demandPublish' || name === 'isNotifiable') onHandleChange(true);

  return (
    <>
      {secondLabel && name !== 'isPublic' && (
        <Title level={5}>Notifier les utilisateurs Ensembl' : </Title>
      )}
      <Space>
        <label>{placeholder}</label>
        <div id={id}>
          <AntdSwitch
            onChange={onHandleChange}
            defaultChecked={defaultChecked}
            disabled={isDisabled}
          />
        </div>
        {secondLabel && <span>{secondLabel}</span>}
        {name === 'isPublic' && (
          <Tooltip
            placement="top"
            title="Cette option permet de publier uniquement dans les villes des groupes sélectionnés."
          >
            <InfoCircleOutlined style={{ cursor: 'pointer' }} />
          </Tooltip>
        )}
        {name === 'isPrivateResult' && (
          <Tooltip
            placement="top"
            title="Activé : le nom des votants n'est affiché nulle part, ni dans l'application ni dans Pilotage. Désactivé : dans l'application, les membres qui ont voté voient qui a choisi chaque réponse ; dans Pilotage, la photo des votants s'affiche sous chaque réponse. Dans les deux cas, les membres voient les pourcentages après avoir voté. Ce réglage ne change pas qui voit le sondage, et ne peut plus être modifié après la publication."
          >
            <InfoCircleOutlined style={{ cursor: 'pointer' }} />
          </Tooltip>
        )}
      </Space>
    </>
  );
};
